import React, { useCallback, useEffect, useState } from 'react'
import { InfGenerDirectivoSolicHEDTO } from './TypesAprobacionHE';
import { ObtenerInformacionGeneral } from './ServicesDirectivoSolicitudes';
import { showAlert } from 'components/Admin/Horas Extras/Parametros Horas Extras/Actividades/ActividadesHorasExtras';
import Cargando from 'components/Varios/Cargando';
import TableAprobarSolicitudes from './TableAprobarSolicitudes';
import { Col, Row } from 'react-bootstrap';
import CardRegimenHE from '../PlanificacionHE/CardRegimenHE';
import { listadoMeses } from 'functions/DatesFunctions';

type stateInformacionSolicitudes = {
    informacionApro: InfGenerDirectivoSolicHEDTO | undefined,
    mensajeError: string,
}

export default function AprobacionSolicitudesHE() {

    const defaultEstado: stateInformacionSolicitudes = {
        informacionApro: undefined,
        mensajeError: "",
    }
    //Ya que es el mes anterior al actual, lo dejamos con el getMonth() -1
    const mesHoy = (new Date()).getMonth() - 1;

    const [loading, setloading] = useState(false);
    const [informacionAprobacion, setinformacionAprobacion] = useState<stateInformacionSolicitudes>(defaultEstado)
    const [anio, setanio] = useState<number | null>(null);
    const [presupuestoDevengar, setpresupuestoDevengar] = useState<number | null>(null);
    const [planifMes, setplanifMes] = useState<number | null>(null);
    const [solAprobadas, setsolAprobadas] = useState<number | null>(null);

    async function ObtenerDatosGenerales() {
        setloading(true)
        const mensajeErrorDefault = "No ha sido posible obtener información de las solicitudes pendientes de aprobar";
        const respuesta = await ObtenerInformacionGeneral();
        if (respuesta.status === 200 && respuesta.dataResponse && typeof (respuesta.dataResponse) !== "string") {
            const datos = respuesta.dataResponse;
            if (typeof datos === "string") {
                setinformacionAprobacion({ ...informacionAprobacion, mensajeError: datos });
            }
            else {
                setinformacionAprobacion({ ...informacionAprobacion, informacionApro: datos });
                datos.contenidoCard.map((d) => {
                    if (d.idRegimenLaboral == 999) {
                        setpresupuestoDevengar(d.presupuestoDevengar);
                        setplanifMes(d.planificadoActual);
                        setsolAprobadas(d.devengadoNoPagado);
                    }
                })
            }
        }
        else if (respuesta.status === 200 && respuesta.dataResponse && typeof (respuesta.dataResponse) === "string") {
            showAlert(respuesta.dataResponse, false);
        }
        else if (respuesta.status === 409) {
            showAlert(respuesta.errorMessage ?? mensajeErrorDefault, false)
        }
        else {
            showAlert(mensajeErrorDefault, false);
        }
        setloading(false)
    }

    const actualizar = async () => {
        ObtenerDatosGenerales();
    };

    useEffect(() => {
        window.location.href = "https://th.espol.edu.ec/directivo/aprobaciondirectivos";
        //const fecha = new Date();
        //setanio(fecha.getFullYear());
        //ObtenerDatosGenerales();
    }, [])

    const totalSolicitudes = (informacionAprobacion.informacionApro?.solicitudes.reduce((acc, row) => acc + (row.tvhorasextras ?? 0), 0) ?? 0) + (solAprobadas ?? 0);

    const contenidoCardRegimen = (
        <Row>
            <Col xl={12}>
                <Row>
                    {informacionAprobacion.informacionApro?.contenidoCard.map((regimen, index) => (
                        <Col xl={4} key={index} className="mb-3 same-height-container">
                            <CardRegimenHE
                                regimenLaboralPlan={regimen}
                                index={index}
                                tipo='SOLICITUD'
                                idunidad={informacionAprobacion.informacionApro?.informacionAprobador.idEstructuraOrganicaAprobacion }
                            />
                        </Col>
                    ))}
                </Row>
            </Col>
        </Row>
    );


    return (
        <div className='content'>
            <div style={{ alignContent: 'center' }} className="titulo_seccion"> APROBACIÓN DE LA SOLICITUD DE HORAS EXTRAS DEL {anio} </div>
            <br></br>
            {
                loading && <Cargando />
            }
            {
                !loading &&
                <>
                    {informacionAprobacion.mensajeError != "" && (
                        <div className="alert alert-danger">{informacionAprobacion.mensajeError}</div>
                    )}
                    {informacionAprobacion.informacionApro && (
                        <>
                            {contenidoCardRegimen}
                            {informacionAprobacion.informacionApro.solicitudes && mesHoy >= 0 && (
                                <>
                                    <span className='textEspolColor_Red'> Su planificación del mes {listadoMeses[mesHoy].mes} fue de $ {informacionAprobacion.informacionApro.valorPlanificacionMesAnterior} y las solicitudes aprobadas y por aprobar suman $ {totalSolicitudes.toFixed(2)} </span>
                                    <br></br>
                                </>
                            )}
                            <br></br>
                            <TableAprobarSolicitudes
                                informacionContenido={informacionAprobacion.informacionApro}
                                presupuestoDev={presupuestoDevengar}
                                actualizacionDatos={actualizar}
                            />
                        </>
                    )}
                </>
            }
        </div>
    )
}
